import React from 'react'
import './Services.scss'
import H2 from '../Fonts/H2/H2'
import H3 from '../Fonts/H3/H3'
import P from '../Fonts/P/P'
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from 'react-bootstrap';
import Vimeo from '@u-wave/react-vimeo';

const Services = ({data}) => {
    return (
        <div className='services'>
            {data.map(service => {
                if (service.id === 420) { //the-team section
                    return  (
                        <section id={service.slug}>
                            <div className='block-title'>
                                <H2 text={service.title.rendered} />
                            </div>
                            <div className='content content--members'>
                                {/* <div dangerouslySetInnerHTML={{ __html: service.content.rendered }}></div> */}
                                {service.acf.team_member.map(member => {
                                    return (
                                        <div className='member'>
                                            <img src={member.avatar.sizes.medium} alt={member.name} />
                                            <H3 text={member.name} />
                                            <P text={member.position} />
                                            <P text={member.position_2} />
                                        </div>
                                    )
                                })}
                            </div>
                        </section>
                    )
                }
                if (service.id === 421) { //locations section
                    return  (
                        <section id={service.slug}>
                            <div className='block-title'>
                                <H2 text={service.title.rendered} />
                            </div>
                            <div className='content'>
                                <div dangerouslySetInnerHTML={{ __html: service.content.rendered }} className='mt-3'></div>
                                <Row>
                                    <Col xs={12}>
                                        <img src={service.acf.thumbnail_image} alt={service.title.rendered} className='mt-3'/>
                                    </Col>
                                </Row>
                                <Button variant='primary' className='mt-4' href={service.acf.view_more_url}>
                                    <P text='View more' />
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                                </Button>
                            </div>
                        </section>
                    )
                }
                if (service.id === 425) { //studios&backlots section
                    return  (
                        <section id={service.slug}>
                            <div className='block-title'>
                                <H2 text={service.title.rendered} />
                            </div>
                            <div className='content'>
                                <div dangerouslySetInnerHTML={{ __html: service.content.rendered }} className='mt-3'></div>
                                <Row>
                                    <Col xs={12}>
                                        <img src={service.acf.thumbnail_image} alt={service.title.rendered} className='mt-3'/>
                                    </Col>
                                </Row>
                                <Button variant='primary' className='mt-4' href={service.acf.view_more_url}>
                                    <P text='View more' />
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                                </Button>
                            </div>
                        </section>
                    )
                }
                if (service.id === 424) { //tax rebate section
                    return  (
                        <section id={service.slug}>
                            <div className='block-title'>
                                <H2 text={service.title.rendered} />
                            </div>
                            <div className='content'>
                                <div dangerouslySetInnerHTML={{ __html: service.content.rendered }} className='mt-3'></div>
                                <Row className='mt-3'>
                                    {service.acf.info_list.map(data => {
                                        return (
                                            <Col xs={12}>
                                                <div className='data-labeled'>
                                                    <div className='flex'>
                                                        <div className='data-label'>{data.label}</div>
                                                        <div className='data-text'>{data.text}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </div>
                        </section>
                    )
                }
                if (service.id === 423) { //hungarian lifestyle section
                    return  (
                        <section id={service.slug}>
                            <div className='block-title'>
                                <H2 text={service.title.rendered} />
                            </div>
                            <div className='content'>
                                <div dangerouslySetInnerHTML={{ __html: service.content.rendered }} className='mt-3'></div>
                                <Row>
                                    <Col xs={12}>
                                        <img src={service.acf.thumbnail_image} alt={service.title.rendered} className='mt-3'/>
                                    </Col>
                                </Row>
                                <div dangerouslySetInnerHTML={{ __html: service.acf.additional_text }} className='mt-3'></div>
                            </div>
                        </section>
                    )
                } if (service.id === 422) { //glimps of us section
                    return  (
                        <section id={service.slug}>
                            <div className='block-title'>
                                <H2 text={service.title.rendered} />
                            </div>
                            <div className='content'>
                                <Vimeo className="video" video={service.acf.vimeo_id} />
                            </div>
                        </section>
                    )
                } else {
                    return  (
                        <section id={service.slug}>
                            <H2 text={service.title.rendered} className='title--service' />
                            <div dangerouslySetInnerHTML={{ __html: service.content.rendered }} className='text-white'></div>
                        </section>
                    )
                }
            })}
        </div>
    )
  
}

export default Services